<template>
    <div id="divForgotUsernameOrPassword">
        <div class="header-nav">
            <ul class="menu">
                <li><span v-text="'Forgot ' + getActionType" /></li>
            </ul>
        </div>

        <div id="divContent" class="main-content-row">
            <p class="custom-margin-bottom"> <span v-text="'Please enter your information below to get your ' + getActionType + '.'"></span></p>
            <form @submit.prevent="sendData">
                <div class="form-group">
                    <div class="input-group" v-if="!showUsername" style="padding-top:10px;">
                        <label for="username" class="form-label"><b>{{ $t("message.username") }}</b></label><label class="controlLabel custom-error-message">*</label>
                        <input id="username" type="text" v-model.trim="username" class="form-control" ref="username" autofocus />
                    </div>
                </div>
                <div class="form-group">
                    <div class="input-group">
                        <label for="contact" class="form-label"><b>{{ $t("message.phoneOrEmail") }}</b></label><label class="controlLabel custom-error-message">*</label>
                        <input id="contact" type="text" v-model.trim="contact" class="form-control" ref="phoneOrEmail" aria-required="true" />            
                    </div>
                </div>
                <div class="form-group">
                    <div class="input-group">
                        <label for="lastName" class="form-label"><b>{{ $t("message.lastName") }}</b></label><label class="controlLabel custom-error-message">*</label>
                        <input id="lastName" type="text" v-model.trim="lastName" class="form-control" aria-required="true" />            
                    </div>
                </div>

                <button type="submit" class="btn btn-sm btn-primary btn-block" @click.prevent="sendData" aria-label="Submit">{{ $t("message.submit") }}</button>
            </form>            

            <div class="login-links">
                <ul class="custom-page-link">
                    <li><router-link to="/login" class="page-link">{{ $t("message.backToLogin") }}</router-link></li>
                </ul>
            </div>   
        </div>

    </div>
</template>

<script>
import axios from "axios";

export default {
    name: 'ForgotUsernameOrPassword',
    props: ['type'],
    data() {
        return {
            //Much of this is just to match the format of the object in the system.
            actionType: this.type.toLowerCase().trim(),
            username: "",
            contact: "",
            lastName: "",
            zipcode: "",
            isForgotUserName: ""
        }
    },
    computed: {
        showUsername: function() {
            return this.actionType == "username";
        },
        getActionType: function() {
            var tmpActionType = this.actionType;
            return tmpActionType.charAt(0).toUpperCase() + tmpActionType.substr(1);
        },
        isForgotPassword() {
            return this.actionType === "password";
        }    
    },
    mounted() {
        if (this.isForgotPassword) {
            this.$refs.username.focus();
        } else {
            this.$refs.phoneOrEmail.focus();
        }
    },
    methods: {
        sendData()  {
            // For 'Forgot a Password' validate username input
            if (this.isForgotPassword) {
                if (this.username === "") {
                    this.showError('Username cannot be empty.');
                    return;
                }
            }           

            if (this.contact === "") {
                this.showError('You must enter either the phone number or email address associated with the account.');
                return;
            }

            if (!this.$checkEmail(this.contact) && !this.$checkPhone(this.contact)) {
                this.showError('The value you entered is neither a phone number nor an email address.');
                return;
            }

            if (this.lastName === "") {
                this.showError('You must enter a last name to get your password.');
                return;
            }

            this.isForgotUserName = this.showUsername;

            axios({
                method: "POST",
                url: this.$httpAxiosBaseUrl() + "Login/ForgotNameOrPassword",
                data: {
                    "userData": this.$data
                }
            }).then(result => {
                var response = result.data;
                if (response !== "") {
                    this.showError(response);
                }
                else {
                    this.$store.commit('setLoginMessage', 'Your ' + this.actionType + ' has been sent.');
                    this.$router.push({ name: "Login" });
                }
            })
        },
        showError(message) {
            var formattedMessage = this.$formatResponseLinks(message);
            
            this.$toasted.global.error(formattedMessage);
            this.$announcer.set(formattedMessage);
        }
    }
}
</script>
